<template>
  <video
    id="trailer-player"
    playsinline
    autoplay
    :muted="isMuted"
    :poster="poster"
  >
    <source
      v-for="source in videoSources"
      :key="source.src"
      :src="source.src"
      :type="source.type"
    >
  </video>
</template>

<script>
import enableInlineVideo from 'iphone-inline-video';

const stringSourceToObjectSource = (source) => {
  if (typeof source === 'string') {
    const [extension] = source.split('.').slice(-1);
    return {
      src: source,
      type: `video/${extension}`,
    };
  }
  return source;
};

export default {
  props: {
    sources: {
      type: [Array, String],
      default: undefined,
    },
    poster: {
      type: String,
      default: undefined,
    },
    isMuted: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    videoSources() {
      let source;
      if (typeof (this.sources) !== 'string') {
        source = this.sources.map(stringSourceToObjectSource);
      } else {
        source = [{ src: this.sources, type: 'video/mp4' }];
      }
      return source;
    },
  },
  mounted() {
    enableInlineVideo(this.$el);
    this.registerEventListener();
    this.play();
  },
  beforeDestroy() {
    this.unregisterEventListener();
  },
  methods: {
    play() {
      const videoEl = this.$el;
      if (!videoEl.paused) return;

      try {
        videoEl.play();

        if (videoEl.paused) {
          // Video is still not playing, try to use the next user input to trigger play
          return;
        }

        // Video is played. Stop capturing user input for playback
        this.unregisterEventListener();
      } catch {
        // Doesn't matter. It is ok for video to fail
        // Besides, I suspect we can't force it any further
      }
    },

    registerEventListener() {
      document.body.addEventListener('touchstart', this.play);
      document.body.addEventListener('click', this.play);
    },
    unregisterEventListener() {
      document.body.removeEventListener('touchstart', this.play);
      document.body.removeEventListener('click', this.play);
    },
  },
};
</script>
